'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@rc-steps/lib/index.js
 ** module id = 503
 ** module chunks = 0 1
 **/